import React, { useEffect, useState, useRef } from 'react';
import ListView from '../list/ListView';
import ApiService from '../../services/ApiService';

const RedisList = () => {
  const [rowData, setRowData] = useState([]);
  const listViewRef = useRef(null);

  const fetchLocks = () => {
    ApiService.get('cache/locks').then(response => {
      setRowData(response.data.map(key => ({ key })));
    });
  };

  const handleRemoveItem = (itemName, itemId) => {
    ApiService.post('cache/lock/remove', { key: itemId }).then(response => {
      if (response.data === itemId) {
        setRowData(rowData.filter(key => key !== itemId));
        if (listViewRef.current) {
          listViewRef.current.removeRowById(itemId);
        }
      }
    });
  };

  const columnDefs = [
    {
      headerName: 'Key',
      field: 'key',
    },
  ];

  useEffect(() => {
    fetchLocks();
  }, []);

  return (
    <ListView
      ref={listViewRef}
      canAdd={false}
      canCopy={false}
      canEdit={false}
      canRemove={true}
      columnDefs={columnDefs}
      handleRemoveItem={handleRemoveItem}
      idFieldName="key"
      itemName="UST11"
      rowData={rowData}
    />
  );
};

export default RedisList;
